import React, { useState, useEffect } from 'react'
import Spinner from 'react-spinkit'
import ProLinkTable from '../../components/ProLinckTable'
import SarafanApiClient from '../../services/SarafanApiClient'

function TopProLinksPage() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [funnel, setFunnel] = useState([])

  useEffect(() => {
    SarafanApiClient.topProLinks()
      .then((response) => {
        setLoading(false)
        setFunnel(response.body.data)
      })
      .catch((error) => {
        setLoading(false)
        setError(error)
      })
  }, [])

  const columns = [
    {
      title: 'Пользователь',
      field: 'code',
      sortable: true,
    },
    {
      title: 'Рекомендаций по про ссылке',
      field: 'count7',
      sortable: true,
      right: true,
    },
  ]

  return (
    <div  style={{ width: '100%' }}>
      {
        loading &&
        <div>
          <Spinner name="circle" className="spinner" fadeIn="quarter" color="#3897dc"/>
          <div className="overlay">
          </div>
        </div>
      }
      <div>
        <h3>Топ про ссылок</h3>
      </div>
      {
        error &&
        <div className="form-group">
          <div className="alert alert-danger">
            <strong>Ошибка!</strong> {error}
          </div>
        </div>
      }
      <br/>
      <ProLinkTable data={funnel} columns={columns}/>
    </div>
  )
}

export default TopProLinksPage



// WEBPACK FOOTER //
// ./src/pages/TopProLinksPage/index.jsx